// v10/src/utils/planFeaturesMatrix.js
//
// Matriz de planes — ESPEJO del backend (utils/planFeatures.js).
// IMPORTANTE: si modificás la matriz del backend, modificá este archivo también.
// No hay sincronización automática.
//
// Esta matriz se usa SOLO para mostrar presets en el SuperAdminPanel.
// El gating real corre con user.effective_features (computado por backend en /auth/me).

export const PLAN_FEATURES_MATRIX = {
  trial: {
    // Gestión administrativa
    flight_log: true,
    suppliers: false,
    digital_signature: false,
    quick_log_enabled: false,
    qr_access: false,
    audit_log: false,
    custom_checklists: false,
    checklist_versioning: false,
    internal_audit_reports: false,
    priority_support: false,
    sla: false,
    // Voice
    advanced_voice: true,
    voice_characters_limit: 5000,
    // Safety-critical (Enterprise only)
    flow_mode: false,
    wb: false,
    navigation: false,
    pre_landing: false,
    emergency_trainer: false,
    icao_english: false,
    anac_export: false,
    // Límites
    max_aircraft: 1,
    max_users: 5,
    trial_days: 14,
  },
  basic: {
    flight_log: true,
    suppliers: false,
    digital_signature: false,
    quick_log_enabled: false,
    qr_access: false,
    audit_log: false,
    custom_checklists: true,
    checklist_versioning: false,
    internal_audit_reports: false,
    priority_support: false,
    sla: false,
    advanced_voice: true,
    voice_characters_limit: 15000,
    flow_mode: false,
    wb: false,
    navigation: false,
    pre_landing: false,
    emergency_trainer: false,
    icao_english: false,
    anac_export: false,
    max_aircraft: 8,
    max_users: 25,
    trial_days: null,
  },
  pro: {
    flight_log: true,
    suppliers: true,
    digital_signature: true,
    quick_log_enabled: false,
    qr_access: true,
    audit_log: true,
    custom_checklists: true,
    checklist_versioning: true,
    internal_audit_reports: true,
    priority_support: true,
    sla: false,
    advanced_voice: true,
    voice_characters_limit: 999999,
    flow_mode: false,
    wb: false,
    navigation: false,
    pre_landing: false,
    emergency_trainer: false,
    icao_english: false,
    anac_export: false,
    max_aircraft: null,
    max_users: null,
    trial_days: null,
  },
  enterprise: {
    flight_log: true,
    suppliers: true,
    digital_signature: true,
    quick_log_enabled: false,
    qr_access: true,
    audit_log: true,
    custom_checklists: true,
    checklist_versioning: true,
    internal_audit_reports: true,
    priority_support: true,
    sla: true,
    advanced_voice: true,
    voice_characters_limit: 999999,
    flow_mode: true,
    wb: true,
    navigation: true,
    pre_landing: true,
    emergency_trainer: true,
    icao_english: true,
    anac_export: true,
    max_aircraft: null,
    max_users: null,
    trial_days: null,
  },
};
